// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-create-category .v-text-field--outlined fieldset{border:2px solid #cdcdcd}.menu-create-category .v-text-field input{color:#8a8a8a;font-size:13px;font-weight:500}.menu-create-category .v-text-field .v-input__slot:after{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
